module.exports = __webpack_public_path__ + "img/vertical_2_1_5012.0803a643.png";